import React, { FunctionComponent, useMemo } from 'react';

import dateToString from '@ps-int/ufo-helpers/lib/date/date-to-string';
import { SplitGroup } from '@yandex-360/orb-components/dist/components/SplitGroup';
import cn from 'classnames';
import { useSelector } from 'react-redux';

import { useActions } from '../../../../../../shared/hooks';
import { useOnMount } from '../../../../../../shared/hooks/useOnMount';
import { getDatesBounds } from '../../../../helpers/get-dates-bounds';
import { useIsOneColLayout } from '../../../../hooks';
import { selectFilterFromTo } from '../../../../selectors';
import { setFilterFromTo } from '../../slice';
import { DatePicker } from '../date-picker';
import styles from './styles.css';

export const FilterPeriodPicker: FunctionComponent = () => {
    const datesBounds = useMemo(getDatesBounds, []);
    const actions = useActions({ setFilterFromTo });
    useOnMount(() => {
        actions.setFilterFromTo({
            from: dateToString(datesBounds.from, 'YYYY-MM-DD'),
            to: dateToString(datesBounds.to, 'YYYY-MM-DD'),
        });
    });
    const { from: currentFrom, to: currentTo } = useSelector(selectFilterFromTo);
    const isOneColLayout = useIsOneColLayout();
    return (
        <SplitGroup className={cn(styles.splitGroup, { [styles.oneColLayout]: isOneColLayout })}>
            <DatePicker
                className={styles.filterPeriodPicker}
                bounds={['from']}
                defaultDate={datesBounds.from}
                maxValue={new Date(currentTo as string)}
            />
            <DatePicker
                className={styles.filterPeriodPicker}
                bounds={['to']}
                defaultDate={datesBounds.to}
                minValue={new Date(currentFrom as string)}
            />
        </SplitGroup>
    );
};
